import { userManifestApi } from '../../api/userManifestApi'

import { addNotification } from './notificationActions'

import { userManifestSignal, userManifestLoadedSignal, userManifestErrorSignal } from '../signals/userManifestSignals'

import { buildCacheKey, checkCache, setCache } from '../../utils/actionCache'

const USER_MANIFEST_TTL = 5 * 60 * 1000
const USER_MANIFEST_CACHE_PREFIX = 'fetchUserManifest'

export const fetchUserManifestByAccessToken = async (config, accessToken, forceRefresh = false) => {
    const cacheKey = buildCacheKey(USER_MANIFEST_CACHE_PREFIX, accessToken)
    if (!forceRefresh) {
        const cached = checkCache(cacheKey, USER_MANIFEST_TTL)
        if (cached) {
            return cached
        }
    }

    userManifestLoadedSignal.value = false
    userManifestSignal.value = null
    return await userManifestApi.fetchUserManifestByAccessToken(config, accessToken).then(
        (userManifest) => {
            userManifestSignal.value = userManifest
            userManifestLoadedSignal.value = true
            setCache(cacheKey, userManifest)
            return userManifestSignal.value
        }
    ).catch(
        (err) => {
            userManifestErrorSignal.value = err
            console.log(err)
            addNotification(`Unable to load user manifest: ${err}`)
        }
    )
}